import React, { forwardRef } from "react";
import { Card, Container } from "react-bootstrap";
import { getModeNameByid } from "utils/AppUtils";

import { useTranslation } from "react-i18next";

const DayClosureSummariesTable = forwardRef(function DayClosureSummariesTable({ dayClosureData }, ref) {
  const {
    t,
  } = useTranslation();

  const getModeOrders = (modeId, dayClosureData) => {
    switch (modeId) {
      case 1:
        return dayClosureData.takeAwayOrders.toFixed(0);
      case 2:
        return dayClosureData.deliveryOrders.toFixed(0);
      case 3:
        return dayClosureData.restaurantOrders.toFixed(0);
    }
  };
  return (
    <Card className="regular-table-with-color" ref={ref}>
      <Card.Body className="table-responsive p-0">
        {dayClosureData.users.map((data) => {
          return (
            <>
              <h5 className="text-center mt-3 font-weight-bold">{data.name}</h5>
              <hr />
              <Container className="mt-2">
                <div className="row mb-2">
                  {data.paymentMethods.map((paymentMethod) => {
                    return (
                      <>
                        <div className="col-6 text-start fw-bold">{`${paymentMethod.name}:`}</div>
                        <div className="col-6 text-end">{paymentMethod.total.toFixed(2)} €</div>
                      </>
                    );
                  })}

                  <div className="col-6 text-start fw-bold">{t("summaries.paid")}</div>
                  <div className="col-6 text-end">{data.payed.toFixed(2)} €</div>
                  <div className="col-6 text-start fw-bold">{t("summaries.discounts")}</div>
                  <div className="col-6 text-end">{data.discount.toFixed(2)} €</div>
                  <div className="col-6 text-start fw-bold">{t("summaries.cancellations")}</div>
                  <div className="col-6 text-end">{data.cancelled.toFixed(2)} €</div>
                  <div className="col-6 text-start fw-bold">{t("tables.headers.wastage")}</div>
                  <div className="col-6 text-end">{data.destroyed.toFixed(2)} €</div>
                  <div className="col-6 text-start fw-bold">{t("summaries.orders")}</div>
                  <div className="col-6 text-end">{data.orders}</div>
                  <div className="col-6 text-start fw-bold">{t("summaries.revenue")}</div>
                  <div className="col-6 text-end">{data.turnover.toFixed(2)} €</div>
                </div>
              </Container>
            </>
          );
        })}

        <h5 className="text-center mt-3 font-weight-bold">{t("tables.headers.total")}</h5>
        <hr />
        <Container className="mt-2">
          <div className="row mb-2">
            <div className="col-6 text-start fw-bold">ATOMA:</div>
            <div className="col-6 text-end">{dayClosureData.people}</div>

            {dayClosureData.modes.map((mode) => (
              <>
                <div className="col-6 text-start fw-bold">{getModeNameByid(mode.id)}:</div>
                <div className="col-6 text-end">
                  {mode.total.toFixed(2)} € ({getModeOrders(mode.id, dayClosureData)})
                </div>
              </>
            ))}

            {dayClosureData.total.paymentMethods.map((row) => (
              <>
                <div className="col-6 text-start fw-bold">{row.name}:</div>
                <div className="col-6 text-end">{row.total.toFixed(2)} €</div>
              </>
            ))}

            <div className="col-6 text-start fw-bold">{t("summaries.open")}</div>
            <div className="col-6 text-end">{dayClosureData.open.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("summaries.paid")}</div>
            <div className="col-6 text-end">{dayClosureData.total.payed.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("summaries.discounts")}</div>
            <div className="col-6 text-end">{dayClosureData.total.discount.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("summaries.cancellations")}</div>
            <div className="col-6 text-end">{dayClosureData.total.cancelled.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("tables.headers.wastage")}</div>
            <div className="col-6 text-end">{dayClosureData.total.destroyed.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("summaries.orders")}</div>
            <div className="col-6 text-end">{dayClosureData.total.orders}</div>
            <div className="col-6 text-start fw-bold">{t("summaries.revenue")}</div>
            <div className="col-6 text-end">{(dayClosureData.open + dayClosureData.total.turnover).toFixed(2)} €</div>
          </div>
        </Container>
        <h5 className="text-center mt-3 font-weight-bold">{t("tables.headers.vatDotted")}</h5>
        <hr />
        <Container className="mt-2">
          <div className="row mb-2">
            {dayClosureData.vats.map((vat) => (
              <>
                <div className="col-6 text-start fw-bold">{vat.vat_percent}:</div>
                <div className="col-6 text-end">{vat.total.toFixed(2)} €</div>
              </>
            ))}
          </div>
        </Container>
      </Card.Body>
    </Card>
  );
});

export default DayClosureSummariesTable;
